export function ErrorMessage({ message, children, status = 'error' }) {
  const styles = {
    error: {
      bg: '#fcebea',
      border: '#cc1f1a',
      color: '#cc1f1a'
    },
    warning: {
      bg: '#f1deca',
      border: 'orange',
      color: '#4f4f4f'
    },
    success: {
      bg: '#d0f0c0',
      border: '#62dd62',
      color: '#4f4f4f'
    }
  };

  let formattedMessage = message;
  if (typeof message === 'string') {
    formattedMessage = message.split('\n').map((line, index) => (
      <p key={index} style={{ margin: 0 }}>
        {line}
      </p>
    ));
  }

  return (
    <div
      style={{
        backgroundColor: styles[status].bg,
        borderLeft: `4px solid ${styles[status].border}`,
        color: styles[status].color,
        flexBasis: '100%',
        padding: '12px',
        margin: '0 0 24px',
        fontFamily: '"Roboto", Arial, Helvetica, sans-serif'
      }}>
      {formattedMessage} {children}
    </div>
  );
}
